import React from "react";
import "../assets/Mailbox.css";
import Mail from "../Components/Mail.js";
import NavBar from "../Components/NavBar";
import bottle from "../assets/bottlestamp.png";
import heartStamp from "../assets/heartstamp.png";
import waveStamp from "../assets/wavestamp.png";
import stamp4 from "../assets/stamp4.png";
import sailStamp from "../assets/sailstamp.png";

const Mailbox = (props) => {
  const mail = [
    {
      text: "Hi Aria",
      img: bottle,
    },
    {
      text: "Hi Jackie",
      img: heartStamp,
    },
    {
      text: "Hi Renee",
      img: waveStamp,
    },
    {
      text: "Hi Claire",
      img: stamp4,
    },
    {
      text: "Hi Claire",
      img: sailStamp,
    },
    {
      text: "Hi Renee",
      img: waveStamp,
    },
    {
      text: "Hi Aria",
      img: bottle,
    },
  ];

  return (
    <div>
      <NavBar />

      <div className="mailbox-center">
        <div className="header">
          <h3>Welcome to your mailbox!</h3>
        </div>
        <div className="grid lg:grid-cols-2  xl:grid-cols-3 2xl:grid-cols-4 gap-20 mt-20 justify-items-center items-center">
          {mail.map((mail, index) => {
            return (
              <Mail
                key={index}
                {...mail}
                text={props.text}
                sender={props.sender}
                receiver={props.receiver}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Mailbox;
